import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import useFetchData from './useFetchData.ts';

const JobTrendLineGraph: React.FC = () => {
  const csvFilePath = process.env.PUBLIC_URL + '/salaries.csv';
  const data = useFetchData(csvFilePath);

  const processedData = data.reduce((acc, row) => {
    const year = row.work_year;
    if (!acc[year]) {
      acc[year] = { year, totalJobs: 0 };
    }
    acc[year].totalJobs += 1;
    return acc;
  }, {});

  const graphData = Object.values(processedData);

  return (
    <div>
      <h2>Job Trend Line Graph</h2>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={graphData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="totalJobs" stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default JobTrendLineGraph;
